// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"wave-2-portable-air-conditioner_productcontent__3Drei"};